import update from 'immutability-helper';
import { getTextAreaDimensions } from '../../utils';
import getNextLetter from './getNextLetter';

const addTextArea = (textAreas, textArea = undefined) => {
  const nextLetter = getNextLetter(textAreas);
  const newTextArea = textArea || {
    [nextLetter]: {
      height: 5,
      left: 20,
      text: `Text area ${nextLetter}`,
      top: 12,
      type: 'textArea',
      width: 20
    },
  };

  return update(textAreas, {
    $merge: newTextArea
  });
};

const deleteTextArea = (textAreas, { id }) => update(textAreas, { $unset: [id] });

const updateTextArea = (textAreas, { height, id, left, text, top, width }) => (
  update(textAreas, {
    [id]: {
      $merge: {
        height,
        left,
        text,
        top,
        width
      }
    }
  })
);

const moveWithKey = (textAreas, { id, key, left, text, top, height, width }) => {
  switch (key) {
    case 'ArrowUp':
      return updateTextArea(textAreas, { height, id, left, text, top: top - 1, width });
    case 'ArrowDown':
      return updateTextArea(textAreas, { height, id, left, text, top: top + 1, width });
    case 'ArrowLeft':
      return updateTextArea(textAreas, { height, id, left: left - 1, text, top, width });
    case 'ArrowRight':
      return updateTextArea(textAreas, { height, id, left: left + 1, text, top, width });
    default:
      return textAreas;
  }
};

const addVocabTextArea = (textAreas, payload) => {
  const key = Object.keys(payload.textAreaValues)[0];
  const newTextArea = Object.values(payload.textAreaValues)[0];
  const currentTextArea = textAreas[key] || {};
  // When creating a new vocab text area AND the shape is already a circle, move the initial position down.
  const circleOffset = payload.textAreaValues[key].shape !== 'circle' ? 0 : 10;

  if (newTextArea.vocabId === null) return deleteTextArea(textAreas, { id: key });

  // we don't want the new text area to overwrite existing coordinates or dimensions
  const persistentVals = {
    left: payload.linkOption === 'definition' ? (currentTextArea.left || newTextArea.left) : 10,
    top: payload.linkOption === 'definition' ? (currentTextArea.top || (newTextArea.top + circleOffset)) : 10,
    ...getTextAreaDimensions(
      payload.numberOfTextAreas,
      payload.linkOption,
      (currentTextArea.width || newTextArea.width),
      (currentTextArea.height || newTextArea.height),
    ),
  };

  // so we store those and merge those in last
  const newPayload = {
    [key]: {
      ...currentTextArea,
      ...newTextArea,
      ...persistentVals,
    },
  };

  return addTextArea(textAreas, newPayload);
};

const textAreaReducer = (textAreas, { payload, type }) => {
  switch (type) {
    case 'ADD':
      return addTextArea(textAreas, payload);
    case 'ADD_VOCAB_TEXT_AREA':
      return addVocabTextArea(textAreas, payload);
    case 'DELETE':
      return deleteTextArea(textAreas, { id: payload.id });
    case 'UPDATE':
      return updateTextArea(textAreas, payload);
    case 'MOVE_WITH_ARROW_KEY':
      return moveWithKey(textAreas, payload);
    case 'SET_SPACED':
      return update(textAreas, { $merge: payload });
    default:
      return textAreas;
  }
};

export default textAreaReducer;
